export const FETCH_USER_GROUP_HOST_SETTINGS_ID = 'FETCH_USER_GROUP_HOST_SETTINGS_ID';

export const userGroupHostSettingsId = (value: number) => {
    return {
        type: FETCH_USER_GROUP_HOST_SETTINGS_ID,
        payload: value
    }
};

